var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBranchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50977 13.0938V18.3321C3.50977 23.5704 5.60977 25.6704 10.8481 25.6704H17.1364C22.3748 25.6704 24.4748 23.5704 24.4748 18.3321V13.0938",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0032 13.9948C16.1382 13.9948 17.7132 12.2565 17.5032 10.1215L16.7332 2.32812H11.2848L10.5032 10.1215C10.2932 12.2565 11.8682 13.9948 14.0032 13.9948Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3619 13.9948C23.7186 13.9948 25.4453 12.0815 25.2119 9.73646L24.8853 6.52813C24.4653 3.49479 23.2986 2.32812 20.2419 2.32812H16.6836L17.5003 10.5065C17.6986 12.4315 19.4369 13.9948 21.3619 13.9948Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58401 13.9948C8.50901 13.9948 10.2473 12.4315 10.434 10.5065L10.6907 7.92813L11.2507 2.32812H7.69235C4.63568 2.32812 3.46901 3.49479 3.04901 6.52813L2.73401 9.73646C2.50068 12.0815 4.22735 13.9948 6.58401 13.9948Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0026 19.8281C12.0543 19.8281 11.0859 20.7965 11.0859 22.7448V25.6615H16.9193V22.7448C16.9193 20.7965 15.9509 19.8281 14.0026 19.8281Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchIcon);
export default __webpack_public_path__ + "static/media/BranchIcon.2f088f57b28ced4f7687a67d23009245.svg";
export { ForwardRef as ReactComponent };